import React from 'react';
import classNames from 'classnames/bind';
import { ScrollableProductCards } from '@components';
import { Typography } from 'gd-design-library';
import { ProductsResponse, ProductDetailsProductListItem } from '@services';
import styles from '../ProductStaticContent.module.scss';

const CN = 'product-static-content';
const productDetailsItemClassName = `${CN}__product-details-item`;
const productDetailsItemTitleClassName = `${productDetailsItemClassName}__title`;
const cx = classNames.bind(styles);

interface Props {
  productDetailsItem: ProductDetailsProductListItem;
  products: ProductsResponse
}

export const ProductList: React.FC<Props> = ({
  productDetailsItem: {
    product_list: {
      title
    }
  },
  products
}) => (
  <div className={ cx(productDetailsItemClassName) }>
    <Typography className={ cx(productDetailsItemTitleClassName) } variant='h4' >
      {title}
    </Typography>
    <ScrollableProductCards
      products={ products }
      title=''
      analyticsContext={ {
        listId: `product-list-${title}`,
        listName: `Product List - ${title}`
      } }
    />
  </div>
);
